import React, { useState } from "react";
import '../Styles/components.css';
import './CardStyles/CardA.css';
import { MdShoppingCart } from "react-icons/md";
import PopUp from "../PopUps/AddToCart_Popup/PopUp";

const PopupLayout = [{
  des: "block",
  options: "block",
  additional: "block",
  specialInstructions: "block",
}];


const CardA = (props, { children,className, ...restProps }) => {
  const [openModal, setOpenModal] = useState(false);

  const Popup = () => {
    setOpenModal(true);

    // Disables Background Scrolling whilst the SideDrawer/Modal is open
    if (typeof window != 'undefined' && window.document) {
      document.body.style.overflow = 'hidden';
    }
  }

  const ClosePopup = () => {
    setOpenModal(false);

    // Disables Background Scrolling whilst the SideDrawer/Modal is open
    document.body.style.overflow = 'unset';
  }
  return (
    <div onClick={Popup} {...restProps} className={`theme-div CardA-div ${className}` }>
      <div className={`theme-div CardA-div-0`}>
        <div className={`theme-div CardA-div-1`}>
          <div className={`theme-div CardA-div-2`}>
            <div className={`theme-div CardA-div-3`}>
              <div className={`theme-div CardA-div-4`}>
                <div className={`theme-div CardA-div-5`}>
                  <h2 className={`theme-h2 CardA-h2`} children={props.name} />
                </div>
                <div className={`theme-div CardA-div-6`}>
                  <p className={`theme-p CardA-p`} children={props.des} />
                </div>
              </div>
              <div className={`theme-div CardA-div-7`}>
                <div className={`theme-div CardA-div-8`}>
                  <span className={`theme-span CardA-span`}>from Rs.{props.lastprice}</span>
                  <span className={`theme-span CardA-span-0`}> to Rs.{props.discountedprice}</span>
                </div>
                <div className={`theme-div CardA-div-9`}>
                  <span className={`theme-span CardA-span-1`}>{props.percent}%OFF</span>
                </div>
              </div>
              <div className={`theme-div CardA-div-10`}>
                <button className={`theme-button CardA-button`} type="button" onClick={Popup} >
                  <p>Add To Cart  <MdShoppingCart style={{ marginBottom: "-2%" }}></MdShoppingCart></p>
                </button>

              </div>

            </div>
          </div>
        </div>
        <div className={`theme-div CardA-div-11`}>
          <picture className={`theme-picture CardA-picture`}>
            <img className={`theme-img CardA-img`} alt="" src={props.img} />
          </picture>
        </div>
      </div>
      {PopupLayout.map((display) => (
        <PopUp
          key={props.id}
          open={openModal}
          onClose={ClosePopup}
          name={props.name}
          id={props.id}
          price={props.discountedprice}
          des={props.des}
          img={props.img}
          displayDes={display.des}
          displayOption={display.options}
          displayAdditional={display.additional}
          displaySpecialInstruction={display.specialInstructions}
        />
      ))}
    </div>
  )
};
CardA.defaultProps = {
  name: "Name",
  price: "Price",
  img: "https://admin.indolj.io/upload/1679987719-12.jpg",
  des: "lorem ipsum lorem ipsum lorem ipsumlorem ipsumlorem ipsum lorem ipsum",
  lastprice: "Last Price",
  discountedprice: "Discounted Price",
  percent: "Any"
}

export default CardA;
